import React from 'react';
import { ELSModalServiceType } from 'models/els';
import { Box } from 'components/common';
import { ELSFlex, ELSFlexItem, ELSIcon } from 'components/common/els';

/**
 * Reusable modal content for "How does grading work?"
 */
export const GradingInfoContent: React.FC = () => (
  <ELSFlex left>
    <ELSFlexItem className="u-els-margin-right">
      <ELSIcon prefix="gizmo" name="information" size="2x" color="secondary" />
    </ELSFlexItem>
    <ELSFlexItem>
      <h2 className="u-els-font-size-h2 u-els-margin-bottom">How does grading work?</h2>
      <Box mb>SimChart assignments are graded on first attempt only.</Box>
      <Box mb>
        <h3 className="u-els-font-size-h3">Not Graded:</h3>
        <p>Students will not receive a score for the assignment. Instructors may provide feedback to students on charting, after the assignment has been submitted.</p>
      </Box>
      <Box mb>
        <h3 className="u-els-font-size-h3">Pass/Fail:</h3>
        <p>
          Students will receive a Pass for submitting the assignment by the due date. Students will receive a Fail if the assignment is not submitted by the due date.
          Instructors may provide feedback to students on charting, after the assignment has been submitted.
        </p>
      </Box>
      <Box mb>
        <h3 className="u-els-font-size-h3">Scored:</h3>
        <p>
          Students will receive a score based on the number of correct answers to quiz questions within the Case Study. Instructors may provide feedback to students on
          charting, after the assignment has been submitted.
        </p>
      </Box>
    </ELSFlexItem>
  </ELSFlex>
);

/**
 * Helper to open the grading info modal using provided modalService.
 * Callers must pass modalService (e.g. from props provided by ELSWithModalService).
 */
export function openGradingInfoModal(modalService: ELSModalServiceType) {
  modalService.openModal({
    modalId: 'gradingInfoModalId',
    color: 'primary',
    content: <GradingInfoContent />
  });
}